<template lang="pug">
  v-card.elevation-4
    v-card-title.justify-center.grey.lighten-2.elevation-2(v-if="title !== ''")
      span.font-weight-medium {{title}}
    v-card-text(:class="{ 'min-height-loading': loading }" v-rc-loader="loading")
      slot
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
  .min-height-loading {
    height: 100px;
  }
</style>
